// extracted by mini-css-extract-plugin
export default {"container":"iJ53QV","align-right":"VrJmj_","align-left":"DzrcCo","align-justify":"aOMLSG","bare":"TkbCCx"};